import { useContext } from 'react';
import { ToastContext } from './contexts';

export default function useToast() {
  const { setMessage } = useContext(ToastContext);
  return (message) => setMessage(message);
}
